import React, { useEffect } from 'react';

import { Row } from 'antd';

import {
  Form,
  dialogFunction,
  SectionWrapper,
  FormAddButton,
  FormDeleteButton,
  FullWidthSpace,
  InfoWithLabel,
  ProductSubscriptionMappingModal,
} from 'common/components';

import { displayArray } from 'utils/array';
import { useVisibleModal, useFormatMessage } from 'hooks';

import messagesMapping from 'i18n/messages/mapping';

const MAPPING_SCHEMA = [
  {
    fieldName: 'mappingName',
  },
  {
    fieldName: 'mappingDescription',
  },
  {
    fieldName: 'deliveryMethods',
    format: displayArray,
  },
  {
    fieldName: 'formatTypes',
    format: displayArray,
  },
];

const DownloadFolderProductMapping = (props) => {
  const messages = useFormatMessage(messagesMapping);
  const form = Form.useFormInstance();
  const selectedMapping = Form.useWatch('selectedMapping', form);

  const [mappingModalVisible, mappingModalHandler] = useVisibleModal();

  const selectMapping = (mappingData) => {
    form.setFieldsValue({ selectedMapping: mappingData });
  };

  const showDeleteMappingConfirm = () => {
    dialogFunction({
      type: 'warn',
      content: 'Are you sure to delete the selected mapping?',
      okText: 'Delete',
      okButtonProps: {
        type: 'danger',
      },
      onOk: () => {
        selectMapping(null);
      },
    });
  };

  const onClickAddMappingBtn = () => {
    mappingModalHandler.onModal();
  };

  const onClickDeleteMappingBtn = () => {
    showDeleteMappingConfirm();
  };

  const onMappingModalOk = (selectedMapping) => {
    selectMapping(selectedMapping);
    //* auto select product data format
    form.setFieldsValue({ productDataFormat: selectedMapping?.formatTypes });

    mappingModalHandler.offModal();
  };

  const onMappingModalCancel = () => {
    mappingModalHandler.offModal();
  };

  return (
    <>
      <Form.Item name='selectedMapping' hidden></Form.Item>

      {selectedMapping ? (
        <SectionWrapper title='mapping'>
          <FullWidthSpace>
            {MAPPING_SCHEMA.map((schemaItem) => {
              const value = selectedMapping[schemaItem.fieldName];
              const label = messages[schemaItem.fieldName];
              const info = schemaItem.format ? schemaItem.format(value) : value;

              return (
                <InfoWithLabel
                  key={schemaItem.fieldName}
                  label={label}
                  info={info}
                  labelAlign='right'
                  labelColProps={{ flex: '40%' }}
                />
              );
            })}
            <Row justify='end'>
              <FormDeleteButton onClick={onClickDeleteMappingBtn} />
            </Row>
          </FullWidthSpace>
        </SectionWrapper>
      ) : (
        <Form.Item label='Mapping'>
          <FormAddButton onClick={onClickAddMappingBtn} />
        </Form.Item>
      )}
      <ProductSubscriptionMappingModal
        visible={mappingModalVisible}
        onOk={onMappingModalOk}
        onCancel={onMappingModalCancel}
      />
    </>
  );
};

export default DownloadFolderProductMapping;
